import { ServiceActionTypes } from './constants';
import { IService } from 'pages/apps/Services/types';

/**
 * State type
 */
type State = {
    results: IService[];
    totalRecords: number;
    loading: boolean;
    error?: string;
    serviceDetailsById: IService | null;
    isServiceCreated: boolean;
    isServiceUpdated: boolean;
};

/**
 * Initial state
 */
const INIT_STATE: State = {
    results: [],
    totalRecords: 0,
    loading: false,
    serviceDetailsById: null,
    isServiceCreated: false,
    isServiceUpdated: false,
};

/**
 * Action type
 */
type ServiceActionType = {
    type:
    | ServiceActionTypes.API_RESPONSE_SUCCESS
    | ServiceActionTypes.API_RESPONSE_ERROR
    | ServiceActionTypes.GET_SERVICES
    | ServiceActionTypes.GET_SERVICE_DETAILS
    | ServiceActionTypes.ADD_SERVICE
    | ServiceActionTypes.UPDATE_SERVICE
    | ServiceActionTypes.DELETE_SERVICE
    | ServiceActionTypes.RESET;
    payload: {
        actionType?: string;
        data?: any;
        error?: string;
    };
};

/**
 * Reducer
 */
const Services = (state: State = INIT_STATE, action: ServiceActionType): State => {
    switch (action.type) {
        case ServiceActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = action.payload;

            switch (actionType) {
                case ServiceActionTypes.GET_SERVICES: {
                    return {
                        ...state,
                        results: data?.results || [],
                        totalRecords: data?.totalResults || 0,
                        loading: false,
                        error: undefined,
                        isServiceCreated: false,
                        isServiceUpdated: false,
                    };
                }

                case ServiceActionTypes.GET_SERVICE_DETAILS:
                    return {
                        ...state,
                        serviceDetailsById: data || null,
                        loading: false,
                        error: undefined,
                    };

                case ServiceActionTypes.ADD_SERVICE:
                    return {
                        ...state,
                        results: [data, ...state.results],
                        serviceDetailsById: data || null,
                        isServiceCreated: true,
                        loading: false,
                        error: undefined,
                    };

                case ServiceActionTypes.UPDATE_SERVICE:
                    return {
                        ...state,
                        serviceDetailsById: data || null,
                        isServiceUpdated: true,
                        loading: false,
                        error: undefined,
                    };

                case ServiceActionTypes.DELETE_SERVICE:
                    return {
                        ...state,
                        results: state.results.filter(
                            (service) => service.id !== data?.id
                        ),
                        loading: false,
                        error: undefined,
                    };

                default:
                    return state;
            }
        }

        case ServiceActionTypes.API_RESPONSE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case ServiceActionTypes.GET_SERVICES:
            return {
                ...state,
                loading: true,
                isServiceCreated: false,
                isServiceUpdated: false,
            };

        case ServiceActionTypes.ADD_SERVICE:
        case ServiceActionTypes.GET_SERVICE_DETAILS:
        case ServiceActionTypes.UPDATE_SERVICE:
        case ServiceActionTypes.DELETE_SERVICE:
            return {
                ...state,
                loading: true,
            };

        case ServiceActionTypes.RESET:
            return {
                ...INIT_STATE,
            };

        default:
            return state;
    }
};

export default Services;
